import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const SESSION_KEY = "svc_session";

export const getSession = () => JSON.parse(localStorage.getItem(SESSION_KEY) || "null");
export const setSession = (s) => localStorage.setItem(SESSION_KEY, JSON.stringify(s));
export const clearSession = () => localStorage.removeItem(SESSION_KEY);

const pin = () => getSession()?.pin || "";
const adminHeaders = () => ({ headers: { "x-admin-pin": pin() } });
const accessHeaders = () => ({ headers: { "x-access-pin": pin() } });

export const login = async (enteredPin) => {
  const { data } = await axios.post(`${API}/auth/login`, { pin: enteredPin });
  if (data.valid) {
    setSession({
      pin: enteredPin,
      role: data.role,
      location_id: data.location_id,
      location_name: data.location_name,
    });
  }
  return data;
};

export const getSettings = async () => (await axios.get(`${API}/settings`)).data;
export const updateSettings = async (s) =>
  (await axios.put(`${API}/settings`, s, adminHeaders())).data;

export const getLocations = async () => (await axios.get(`${API}/locations`, adminHeaders())).data;
export const createLocation = async (l) => (await axios.post(`${API}/locations`, l, adminHeaders())).data;
export const updateLocation = async (id, l) => (await axios.put(`${API}/locations/${id}`, l, adminHeaders())).data;
export const deleteLocation = async (id) => (await axios.delete(`${API}/locations/${id}`, adminHeaders())).data;

export const getBuildings = async () => (await axios.get(`${API}/buildings`, adminHeaders())).data;
export const createBuilding = async (b) => (await axios.post(`${API}/buildings`, b, adminHeaders())).data;
export const updateBuilding = async (id, b) => (await axios.put(`${API}/buildings/${id}`, b, adminHeaders())).data;
export const deleteBuilding = async (id) => (await axios.delete(`${API}/buildings/${id}`, adminHeaders())).data;

export const getJobs = async () => (await axios.get(`${API}/jobs`, accessHeaders())).data;
export const createJob = async (j) => (await axios.post(`${API}/jobs`, j, adminHeaders())).data;
export const updateJob = async (id, j) => (await axios.put(`${API}/jobs/${id}`, j, adminHeaders())).data;
export const deleteJob = async (id) => (await axios.delete(`${API}/jobs/${id}`, adminHeaders())).data;
export const bulkTriwulan = async (job_ids, triwulan, tahun) =>
  (await axios.post(`${API}/jobs/bulk-triwulan`, { job_ids, triwulan, tahun }, adminHeaders())).data;
export const copyTriwulan = async (payload) =>
  (await axios.post(`${API}/jobs/copy-triwulan`, payload, adminHeaders())).data;

export const aiRecommend = async (payload) => (await axios.post(`${API}/ai/recommend`, payload, adminHeaders())).data;
export const aiSummary = async (payload) => (await axios.post(`${API}/ai/summary`, payload, adminHeaders())).data;
export const aiImportExcel = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return (await axios.post(`${API}/ai/import-excel`, fd, { headers: { "x-admin-pin": pin() } })).data;
};
export const aiImportCommit = async (payload) => (await axios.post(`${API}/ai/import-excel/commit`, payload, adminHeaders())).data;

export const getPrices = async () => (await axios.get(`${API}/prices`, adminHeaders())).data;
export const createPrice = async (p) => (await axios.post(`${API}/prices`, p, adminHeaders())).data;
export const updatePrice = async (id, p) => (await axios.put(`${API}/prices/${id}`, p, adminHeaders())).data;
export const deletePrice = async (id) => (await axios.delete(`${API}/prices/${id}`, adminHeaders())).data;

export const uploadPhoto = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await axios.post(`${API}/upload`, form, {
    headers: { "x-admin-pin": pin(), "Content-Type": "multipart/form-data" },
  });
  return data.path;
};

export const changeAdminPin = async (current_pin, new_pin) => {
  const { data } = await axios.post(`${API}/admin/pin`, { current_pin, new_pin }, adminHeaders());
  const s = getSession();
  if (s) setSession({ ...s, pin: new_pin });
  return data;
};
